
(function () {
  'use strict';
  angular.module('vcdms.vcdoctype')
    .component('doctypeeditor', {
      restrict: 'E',
      bindings: {
        doctype: '<?',
        doctypeid: '<?'
      },
      template: `
        <doctypeform doctype="vm.doctype" parentsave="vm.childsave(doctype)" oncancel="vm.oncancel()"></doctypeform>
        <div ng-show="vm.saved === true" class="alert alert-success spacer-top spacer-bottom">
          <h3><i class="fa fa-check"></i> doctype erfolgreich gespeichert!</h3>
        </div>
        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">
          <h3><i class="fa fa-info"></i> Das Anlegen einer/s neuen doctype wurde abgebrochen!</h3>
        </div>
        <div ng-show="vm.saved === false" class="alert alert-danger spacer-top spacer-bottom">
          <h3>
            <i class="fa fa-warning"></i> doctype konnte nicht gespeichert werden,
            der Fehler wurde protokolliert!
            </h3>
        </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Doctype', 'Rlog', '$timeout',
        function ($log, Doctype, Rlog, $timeout) {
          let vm = this;
          vm.save = save;
          vm.childsave = childsave;
          vm.oncancel = oncancel;
          
          vm.$onInit = function () {
            if ((angular.isUndefined(vm.doctype) || !vm.doctype.hasOwnProperty('_id'))
              && angular.isDefined(vm.doctypeid)) {
              Doctype.$find(vm.doctypeid).$then(function (doctype) {
                vm.doctype = doctype;
              }, function (err) {
                $log.error('doctype not found, id: ', vm.doctypeid, err);
                Rlog.error('doctype', 'doctypeeditor', 'doctype not found', {_id: vm.doctypeid});
              });
            }
          };
          
          function childsave(doctype) {
            // vm.doctype = angular.copy(doctype);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (let key in doctype) {
              if (doctype.hasOwnProperty(key)) {
                vm.doctype[key] = doctype[key];
              }
            }
            vm.save();
          }
          
          function save() {
            if (vm.doctype.$hasPendingActions()) {
              vm.doctype.$cancel();
              vm.doctype.$save().$then(function () {
                vm.saved = true;
                reset('saved');
              }, function (err) {
                vm.saved = false;
                $log.error('saving of doctype failed: ', err);
                Rlog.error('vcutils.doctype', 'doctypeeditor', 'Saving of doctype failed: ', {doctypeid: vm.doctype._id});
              });
            }
            else {
              vm.doctype.$save().$then(function () {
                vm.saved = true;
                reset('saved');
              }, function (err) {
                vm.saved = false;
                reset('saved');
                $log.error('saving of doctype failed: ', err);
                Rlog.error('vcutils.doctype', 'doctypeeditor', 'Saving of doctype failed: ', {doctypeid: vm.doctype._id});
              });
            }
          }
          
          function oncancel() {
            vm.canceled = true;
            reset('canceled');
          }

          function reset(rvar) {
            $timeout(function () {
              delete vm[rvar];
            }, 3500);
          }
          
        }] // controller
    }); // component

// klammerfriedhof
}());
